module.exports = __webpack_public_path__ + "static/media/W00F0003.b7fe21b7.svg";